import { Component, Input, OnInit } from "@angular/core";
import { FormArray, FormControl, FormGroup } from "@angular/forms";

import ActionTypesEnum from "@shared/enums/action-constant.enum";

import { TeamScorecard } from "@shared/models/team-scorecard";

import { CustomEventService } from "@shared/services/custom-event.service";
import { GlobalSettingsService } from "@shared/services/global-settings.service";

import { validateFormControl } from "@shared/utils/form.util";
import { fullNamePropertyCreator } from "@shared/utils/object-mapper.util";

import DateUtil from "@shared/utils/date.util";

import durations from "@shared/variables/durations.variable";

import { subMonths } from "date-fns";
import { Subject, Subscription } from "rxjs";

import { UntilDestroy, untilDestroyed } from "@ngneat/until-destroy";
import { PropertiesService } from "@core/services/properties.service";
import { properties } from "ng-zorro-antd/core/util";

@UntilDestroy()
@Component({
  selector: 'app-initialize-scorecard-modal',
  templateUrl: './initialize-scorecard-modal.component.html'
})
export class InitializeScorecardModalComponent implements OnInit {

  constructor(
    private customEventService: CustomEventService,
    private globalSettingsService: GlobalSettingsService,
    public propertiesService: PropertiesService
  ) { }

  get gitwiser(): FormArray {
    return this.initializeForm.get('Gitwiser') as FormArray;
  }
  @Input() loading = false;
  @Input() stepInnerLoading = false;
  @Input() team: any;
  @Input() selectedDate?: Base.DurationsModel;
  @Input() steps: TeamScorecard.InitializeStepModel[];
  @Input() currentStep: TeamScorecard.InitializeStepModel;
  @Input() currentStepIndex = 0;
  @Input() role: TeamScorecard.TabDetailModel;
  @Input() transferList = [];
  nextStepButtonEnabled = false;
  customEventSubscription: Subscription;
  customEventSubscriptions: Subscription[] = [];
  private stop$ = new Subject<void>(); // Akışı durdurmak için Subject

  formData: TeamScorecard.CreateModel;
  selectedStepKey: string;
  initializeForm: FormGroup;
  dateFormat: string;
  dateText = durations.filter(item => item.key !== 'MONTHLY'
    && item.key !== 'YEARLY' && item.key !== 'FROM_BEGINNING' &&  item.key !== 'TODAY');
  selectRepo: any;
  tempSelectRepo = [];
  tempSelectDeploymentRepo = [];
  tempSelectAgileSpaceRepo = [];
  tempSelectFortifyRepo = [];

  deleteGitwiser: any;
  deleteDORA: any;
  deleteAgileSpace: any;
  isSearching = false;
  eventTriggered = false

  private suggestionFormValue: { datasource: any; project: any; branch: any };
  private stepCodeAnlyzeData: any;

  protected readonly properties = properties;

  ngOnInit(): void {
    this.tempSelectRepo = [];
    this.tempSelectDeploymentRepo = [];
    this.tempSelectAgileSpaceRepo = [];
    this.tempSelectFortifyRepo = [];
    this.dateFormat = this.globalSettingsService.dateFormat;
    if (this.team.developers && this.team.developers.length) {
      this.team.developers.map(fullNamePropertyCreator);
    }
    this.initializeForm = new FormGroup({
      period: new FormControl(this.selectedDate && this.selectedDate.period
        ? this.selectedDate.period
        : 'FROM_LAST_YEAR'),
      range: new FormControl(this.selectedDate && this.selectedDate.fromDate
        ? this.selectedDate.fromDate
        : subMonths(new Date(), 1))
    });
    this.customEventService.eventAnnounced$.pipe(
      untilDestroyed(this)
    ).subscribe(({ action, data }) => {
      if (action === ActionTypesEnum.UPDATE_INITIALIZE_TEAM_SCORE_CARD_DATA) {
        this.changeCurrentStep('not-change');
      }
    });
    this.customEventService.eventAnnounced$
      .pipe(untilDestroyed(this))
      .subscribe(({ action, data }) => {
        if (action === ActionTypesEnum.CREATE_TEAM_SCORECARD_SUCCESS) {
          this.cancelForm();
        }

        if (action === ActionTypesEnum.CREATE_TEAM_SCORECARD_ERROR) {
          console.log('error while updating team scorecard', data);
        }
      });

  }

  changeStep(type: string): void {

    switch (type) {
      case 'create': {
        const { period, range, ...selections } = this.initializeForm.value;
        this.formData = {
          ...this.formData,
          period,
          selections,
          teamId: this.team.id
        };
        this.steps?.forEach((step,_stepIndex) => {
          step.fields?.forEach((field, fieldIndex) => {
            if(field.key === "Gitwiser" ) {
              this.formData.selections["Gitwiser"] = this.tempSelectRepo;
              if (this.tempSelectRepo.length === 1) {
                this.formData.selections["Gitwiser"] = [this.tempSelectRepo];
              }
            }
            if(field.key === 'DeploymentAnalytics') {
              this.formData.selections["DeploymentAnalytics"] = this.tempSelectDeploymentRepo;
              if (this.tempSelectDeploymentRepo.length === 1) {
                this.formData.selections["DeploymentAnalytics"] = [this.tempSelectDeploymentRepo];
              }
            }
            if(field.key === 'AgileSpace') {
              this.formData.selections["AgileSpace"] = this.tempSelectAgileSpaceRepo;
              if (this.tempSelectAgileSpaceRepo.length === 1) {
                this.formData.selections["AgileSpace"] = [this.tempSelectAgileSpaceRepo];
              }
            }

            if (field.affect !== 'branch' && field.affect !== 'projectVersions') {
              return;
            }
            // only sonar step

            if ((field.affect === 'branch' &&  ( step.title === 'Code Quality' || step.title === 'Unit Test Coverage'))) {
              const branches = this.formData.selections[field.key][fieldIndex + 1];
              const projects = this.formData.selections[field.key][fieldIndex].filter(item => !(branches.some(branch => (branch.split("$")[0].includes("datasource:")
                  ? branch.split("$")[1] : branch.split("$")[0]) === (item.includes("datasource:")
                  ? item.split("$")[1] : item))));
              this.formData.selections[field.key] = [[...projects, ...branches]];
            }

            // only fortify step
            if (step.title === 'Fortify' && field.affect === 'projectVersions'){
              const projects = this.formData.selections[field.key].flat().filter(item => item.split("$").length > 2)
              this.formData.selections[field.key] = [projects]
            }
          });
        });
        if (this.initializeForm.get('period').value === 'CUSTOM_DATE') {
          this.formData = {
            ...this.formData,
            from: DateUtil.formatDate(range)
          };
        }
        const filteredSelections = this.formData.selections;
        Object.entries(this.formData.selections).forEach(([key, value]: [string, any]) => {
          if (value.length === 1) {
            filteredSelections[key] = filteredSelections[key][0];
          }
          if (!filteredSelections[key].length) {
            delete filteredSelections[key];
          }
        });
        this.formData.selections = filteredSelections;
        this.customEventService.announceEvent(
          ActionTypesEnum.CREATE_TEAM_SCORECARD,
          {
            formData: this.formData,
            teamId: this.team.id
          },
        );
        break;
      }
      case 'next': {
        if (!this.isStepValid()) {
          console.log('Step is not Valid');
          return;
        }
        this.changeCurrentStep('increase');
        break;
      }
      case 'previous': {
        this.changeCurrentStep('decrease');
        break;
      }
    }
  }

  selectChange(key, index):void {
    const formKey = this.initializeForm.get(key) as FormGroup;
    const formItem = formKey.controls[index];
    if(key === "Gitwiser"  ){
      formItem.setValue(this.tempSelectRepo);
    }

    if (key === "DeploymentAnalytics") {
      formItem.setValue(this.tempSelectDeploymentRepo);
    }

    if (key ==="AgileSpace") {
      formItem.setValue(this.tempSelectAgileSpaceRepo);
    }
    if (key ==="Fortify") {
      formItem.setValue(this.tempSelectFortifyRepo);
    }
  }

  change(event, key, index) {
    const formKey = this.initializeForm.get(key) as FormGroup;
    const formItem = formKey.controls[index];

    if ( key === "Gitwiser"  && formItem.value !== 'on') {
      this.deleteGitwiser = formItem.value
      delete this.deleteGitwiser;
    } else if ( key === "DeploymentAnalytics" && formItem.value !== 'on') {
      this.deleteDORA = formItem.value
      delete this.deleteDORA
    } else if ( key === "AgileSpace" && formItem.value !== 'on') {
      this.deleteAgileSpace = formItem.value
      delete this.deleteAgileSpace
    }

    if (event.from === 'left' && event.to === 'right') {
      if (key === "Gitwiser") {
        this.tempSelectRepo = this.tempSelectRepo.concat(event.list.map((el) => el.key));
        formItem.setValue(this.tempSelectRepo);

      } else if (key === "DeploymentAnalytics") {
        this.tempSelectDeploymentRepo = this.tempSelectDeploymentRepo.concat(event.list.map((el) => el.key))
        formItem.setValue(this.tempSelectDeploymentRepo);
      } else if (key === "AgileSpace") {
        this.tempSelectAgileSpaceRepo = this.tempSelectAgileSpaceRepo.concat(event.list.map((el) => el.key))
        formItem.setValue(this.tempSelectAgileSpaceRepo);
      }
    }

    if (event.from === 'right' && event.to === 'left') {
      if (key === "Gitwiser") {
        this.tempSelectRepo = this.tempSelectRepo.filter(item => {
          const isItemBeingMoved = event.list.some(listItem => listItem.key === item);
          if (isItemBeingMoved) {
            const foundItem = this.currentStep.fields.find(field => field.key === key).data.find(dataItem => dataItem.key === item);
            if (foundItem)
            {foundItem.selected = false};
          }
          return !isItemBeingMoved;
        });
        formItem.setValue(this.tempSelectRepo);
      } else if (key === "DeploymentAnalytics") {
        this.tempSelectDeploymentRepo = this.tempSelectDeploymentRepo.filter(item => {
          const isItemBeingMoved = event.list.some(listItem => listItem.key === item);
          if (isItemBeingMoved) {
            const foundItem = this.currentStep.fields.find(field => field.key === key).data.find(dataItem => dataItem.key === item);
            if (foundItem)
            {foundItem.selected = false};
          }
          return !isItemBeingMoved;
        });
        formItem.setValue(this.tempSelectDeploymentRepo);
      } else if (key === "AgileSpace") {
        this.tempSelectAgileSpaceRepo = this.tempSelectAgileSpaceRepo.filter(item => {
          const isItemBeingMoved = event.list.some(listItem => listItem.key === item);
          if (isItemBeingMoved) {
            const foundItem = this.currentStep.fields.find(field => field.key === key).data.find(dataItem => dataItem.key === item);
            if (foundItem)
            {foundItem.selected = false};
          }
          return !isItemBeingMoved;
        });
        formItem.setValue(this.tempSelectAgileSpaceRepo);
      }
    }
  }

  isStepDisabled(index: number): boolean {
    return index > this.currentStepIndex;
  }

  changeCurrentStep($event: 'increase' | 'decrease' | 'not-change' | number) {
    // reset eventTriggered unsubscribe previous subscriptions
    this.eventTriggered = false;
    this.customEventSubscriptions?.forEach(sub => sub.unsubscribe());
    this.customEventSubscriptions = [];

    if (typeof $event === 'number' && $event > this.currentStepIndex) {
      if (!this.isStepValid()) {
        return;
      }
    }

    this.stepInnerLoading = true;
    this.stop$.next(); // Mevcut akışı durdur
    this.stop$ = new Subject<void>(); // Yeni bir Subject oluştur

    switch ($event) {
      case 'increase': {
        this.currentStepIndex = ++this.currentStepIndex;
        break;
      }
      case 'decrease': {
        this.customEventSubscription?.unsubscribe();
        this.currentStepIndex = --this.currentStepIndex;
        break;
      }
      case 'not-change': {
        this.nextStepButtonEnabled = true;
        break;
      }
      default: {
        this.currentStepIndex = $event;
      }
    }
    this.currentStep = this.currentStepIndex !== 0 && this.steps[this.currentStepIndex - 1];
    if (this.currentStepIndex === 1) {
      this.customEventSubscription?.unsubscribe();
      this.initializeForm.get('Gitwiser')?.valueChanges
        .pipe(untilDestroyed(this))
        .subscribe(value => {
          setTimeout(() => {
            this.customEventSubscription?.unsubscribe();
            if (this.initializeForm.invalid) {
              this.nextStepButtonEnabled = true;
              this.gitwiser.controls.every(control => {
                if (control.invalid || !control.value) {
                  control.markAsDirty();
                  if (!control.value) {
                    control.setErrors({required: true});
                  }
                }
                setTimeout(_ => {
                  control.updateValueAndValidity();
                }, 1);
                // in order to add a new input all previous inputs should be filled
                return control.valid && control.value;
              });
            }
          });
        });
    }
    if (!this.currentStep) {
      return;
    }

    if (this.currentStep.title === 'Code Quality') {
      this.stepCodeAnlyzeData = this.currentStep.fields;
    }

    this.currentStep.fields?.forEach((field, index) => {
      this.selectRepo = field.data;
      let requestedValue;
      let formControl;

      field.data.forEach(item => {
        if (item.selected) {
          requestedValue = item.key;

          if (field.key === "Gitwiser") {
            const value = this.tempSelectRepo.filter(req => req !== requestedValue);
            if (value || this.tempSelectRepo.length === 0) {
              this.tempSelectRepo.push(requestedValue)
            }
          } else if (field.key === "DeploymentAnalytics") {
            const value = this.tempSelectDeploymentRepo.filter(data => data !== requestedValue);
            if (value || this.tempSelectDeploymentRepo.length === 0) {
              this.tempSelectDeploymentRepo.push(requestedValue)
            }
          } else if (field.key === "AgileSpace") {
            const value = this.tempSelectAgileSpaceRepo.filter(data => data !== requestedValue);
            if (value || this.tempSelectAgileSpaceRepo.length === 0) {
              this.tempSelectAgileSpaceRepo.push(requestedValue)
           }
          }

          item.direction = 'right';

          formControl = this.initializeForm.get(field.key).get((index + 1).toString());

          if (field.key === 'Sonar' || field.key === 'UnitTestCoverage' || field.key === 'Fortify') {
            formControl = this.initializeForm.get(field.key).get('1');
            requestedValue = formControl?.value;
            this.eventTriggered = true;
          }

          if (!this.eventTriggered) {
            this.customEventService.announceEvent(ActionTypesEnum.GET_BRANCH_DATA, {
              datasourceId: field.datasourceId,
              value: requestedValue,
              currentStepIndex: this.currentStepIndex,
              affect: field.affect,
              formControl
            });

            this.eventTriggered = true;
          }
        }
      });

      this.customEventSubscription = this.initializeForm.get(field.key).get(index.toString()).valueChanges
        .pipe(untilDestroyed(this))
        .subscribe(value => {
          if (this.isSearching) {
            return;
          } else  {
            const oldValue = this.initializeForm.value[field.key][index];
            if (value === 'on') {
              this.initializeForm.get(field.key).get(index.toString()).setValue(oldValue);
            }

            if (value.length > oldValue.length) {
              requestedValue = value[value.length - 1];
              formControl = this.initializeForm.get(field.key).get((index + 1).toString());

              this.customEventService.announceEvent(ActionTypesEnum.GET_BRANCH_DATA, {
                datasourceId: field.datasourceId,
                value: requestedValue,
                currentStepIndex: this.currentStepIndex,
                formControl,
                affect: field.affect
              });
            }

            if (typeof oldValue !== "string" && value.length < oldValue.length) {
              const deletedValue = oldValue?.find(item => value.indexOf(item) === -1);
              this.checkDeletedValue(index + 1, deletedValue, field);
              this.checkDeletedValue(index + 2, deletedValue, field);
            }
          }

        });

      this.customEventSubscriptions.push(this.customEventSubscription);
    });
    this.stepInnerLoading = false;

  }

  onSearch(searchValue: string): void {
    this.isSearching = searchValue && searchValue.length > 0;
  }


  checkDeletedValue(fieldIndex, deletedValue, field) {
    const filteredField = this.steps[this.currentStepIndex - 1].fields[fieldIndex];
    if (filteredField) {
      filteredField.data = filteredField.data.filter(data => !data.key.includes(deletedValue));
      const formField = this.initializeForm.get(field.key).get((fieldIndex).toString());
      let fieldValue = formField.value.filter(item => !item.includes(deletedValue));
      if (deletedValue === field.datasourceId) {
        filteredField.data = filteredField.data.filter(data => data.key.includes("datasource:") && !data.key.includes(deletedValue));
        fieldValue = formField.value.filter(item => item.includes("datasource:") && !item.includes(deletedValue));
      }
      formField.setValue(fieldValue, { emitEvent: false });
    }
  }

  suggestion() {
    const result = [];
    const gitwiserData = this.gitwiser.value[0];
    const formKey = this.initializeForm.get('DeploymentAnalytics') as FormGroup;
    const formItem = formKey.controls[0];
    formItem.value.forEach(item3 => {
      result.push(item3);
    })
    const newSelectRepo = [];
    this.selectRepo.forEach(item => {
      if(gitwiserData.includes(item.url.split("/gitwiser/")[1])) {
        item.direction = 'right';
        item.selected = true;
        result.push(item.key);
      }
      newSelectRepo.push(item);
    })
    formItem.setValue(result);
    this.selectRepo = newSelectRepo;
    this.tempSelectDeploymentRepo = result
  }

  addonSelected(selectedStep: TeamScorecard.InitializeStepDataModel): void {
    if (selectedStep.selected) {
      return;
    }
    if (this.selectedStepKey) {
      this.initializeForm.removeControl(this.selectedStepKey);
    }
    this.steps = this.steps.map(step => {
      step.data.map(item => {
        item.selected = item.key === selectedStep.key;
        return item;
      });
      return step;
    });
    this.customEventService.announceEvent(ActionTypesEnum.NEXT_STEP_DATA, {
      stepIndex: this.currentStepIndex - 1,
      teamId: this.team.id,
      key: selectedStep.key
    });
    this.selectedStepKey = selectedStep.key;
  }

  cancelForm(): void {
    this.customEventService.announceEvent(ActionTypesEnum.CLOSE_MODAL);
  }

  reloadTabDetail(): void {
    this.customEventService.announceEvent(ActionTypesEnum.NEXT_STEP_DATA, {
      stepIndex: this.currentStepIndex - 1,
      teamId: this.team.id,
      key: this.steps[this.currentStepIndex - 1].data[0].key
    });
  }

  isStepValid(): boolean {
    if (this.currentStepIndex === 0 || this.currentStep.errorTitle) {
      return true;
    }
    for (const field of this.steps[this.currentStepIndex - 1].fields) {
      validateFormControl(this.initializeForm.get(field.key));
      if (this.initializeForm.invalid) {
        this.gitwiser.controls.every(control => {
          if (control.invalid || !control.value) {
            control.markAsDirty();
            if (!control.value) {
              control.setErrors({required: true});
            }
          }
          setTimeout(_ => {
            control.updateValueAndValidity();
          }, 1);
          // in order to add a new input all previous inputs should be filled
          return control.valid && control.value;
        });
        return false;
      }
      if (this.initializeForm.get(field.key).dirty
        && this.initializeForm.get(field.key).errors) {
        return false;
      }
    }
    return true;
  }

  updateCurrentIndex(): void {
    this.currentStep = this.currentStepIndex !== 0 && this.steps[this.currentStepIndex - 1];
  }

  nzFilterOption(inputValue: string, item: any): boolean {
    const itemLabel = item.label ? item.label.toLowerCase() : '';
    const searchText = inputValue ? inputValue.toLowerCase() : '';
    return itemLabel.indexOf(searchText) > -1;
  }

  suspendValueChanges(form, updateFn: () => void) {
    const subscriptions = [];

    // Tüm valueChanges olaylarını kapat
    Object.keys(form.controls).forEach(key => {
      subscriptions.push(form.controls[key].valueChanges.subscribe(() => {}));
    });

    updateFn(); // Güncellemeleri yap

    // Tüm valueChanges olaylarını geri aç
    subscriptions.forEach(sub => sub.unsubscribe());
  }

  suggestionForTestUnit() {
    this.customEventSubscription.unsubscribe();

    const datasource = this.initializeForm.get('Sonar')?.value[0];
    const project = this.initializeForm.get('Sonar')?.value[1];
    const branch = this.initializeForm.get('Sonar')?.value[2];

    const _datasource = this.initializeForm.get('UnitTestCoverage')?.value[0];
    const _project = this.initializeForm.get('UnitTestCoverage')?.value[1];
    const _branch = this.initializeForm.get('UnitTestCoverage')?.value[2];

    this.suggestionFormValue = {
      datasource,
      project,
      branch
    };

    this.suspendValueChanges(
      this.initializeForm.get('UnitTestCoverage'),
      () => {

        const formKey = this.initializeForm.get(
          'UnitTestCoverage'
        ) as FormGroup;
        const  s = this.steps.filter(item=>item.title==='Unit Test Coverage')[0];
        const formItem1 = formKey.controls['0'];
        const formItem2 = formKey.controls['1'];
        const formItem3 = formKey.controls['2'];
        if (datasource !== _datasource) {
          formItem1.setValue([]);
          formItem1.setValue([...datasource]);
        }

        if (project !== _project) {

          formItem2.setValue([]);
          formItem2.setValue([...project]);

        }

        if (branch !== _branch || _branch.length === 0) {
          formItem3.patchValue([]);
          s.fields[2].data= this.stepCodeAnlyzeData[2].data.map((item:any)=>({...item,selected: branch.includes(item.key)}));
        }
      }
    );
    this.customEventSubscription.unsubscribe();
  }
}
